import { useState, useEffect } from 'react';

/** True on narrow (phone) viewports; updates live on resize/rotate. */
export function useIsMobile(breakpoint = 700): boolean {
  const [mobile, setMobile] = useState(() => window.innerWidth < breakpoint);
  useEffect(() => {
    const onResize = () => setMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return mobile;
}
